function module(moduleDefinition) {
  moduleDefinition = Object.assign({
    aliases: [],
    constantValues: [],
    services: [],
    factories: []
  }, moduleDefinition);
  return (constructor) => {
    constructor.module$ = moduleDefinition;
    return constructor;
  };
}

class Module {
}

class Bootstrapper {
}

export { Bootstrapper, Module, module };
//# sourceMappingURL=index.es.js.map
